module.exports = __webpack_public_path__ + "img/insurita-value-two-shape.dc6dae8d.svg";